import {createSlice} from '@reduxjs/toolkit'

interface VisibilityState {
  ActivePage: String | null
}

const initialState: VisibilityState = {
  ActivePage: null, 
}

const visibilitySlice = createSlice({
  name: 'visibility',
  initialState: initialState,
  reducers: {
    setTabVisibility: (state, action) => {
      state.ActivePage = action.payload
    },
  },
})

export const {setTabVisibility} = visibilitySlice.actions
export default visibilitySlice.reducer
